module.exports = __webpack_public_path__ + "97cb6c158dd089ae3578e4e09ddf3822.png";